/* eslint-disable @typescript-eslint/naming-convention */
export interface IConnectorRaw {
  slug: string;
  name: string;
  description: string;
  logo_url: string | null;
  auth_strategy: string;
  capabilities: Record<string, unknown>;
}

export interface IConnectorCatalogPageRaw {
  items: IConnectorRaw[];
  total: number;
  page: number;
  page_size: number;
}

export interface IConnectorCategoriesRaw {
  items: string[];
}
/* eslint-enable @typescript-eslint/naming-convention */

export interface IConnector {
  slug: string;
  name: string;
  description: string;
  logoUrl: string | null;
  authStrategy: string;
  capabilities: Record<string, unknown>;
}

export interface IConnectorCatalogPage {
  items: IConnector[];
  total: number;
  page: number;
  pageSize: number;
}

export const toConnector = (raw: IConnectorRaw): IConnector => ({
  slug: raw.slug,
  name: raw.name,
  description: raw.description,
  logoUrl: raw.logo_url,
  authStrategy: raw.auth_strategy,
  capabilities: raw.capabilities
});

export const toConnectorCatalogPage = (raw: IConnectorCatalogPageRaw): IConnectorCatalogPage => ({
  items: raw.items.map(toConnector),
  total: raw.total,
  page: raw.page,
  pageSize: raw.page_size
});

export const toConnectorCategories = (raw: IConnectorCategoriesRaw): string[] => raw.items;
